/**
 * vue业务相关的过滤器配置入口
 *
 * @since 1.0.0
 * @version 1.0.0
 */
export default {}
